// import { helpers } from 'vuelidate/lib/validators'

const moment = require('moment')

const validDateFormat = (dateString) => {
  if (dateString == null) {
    return false
  }
  return /^\d{2}\.\d{2}\.\d{4}$/.test(dateString.replace(/\u200e/g, ''))
}

const validDateFormatOnlyForNonEmpty = (dateString) => {
  if (dateString == null || dateString === '') {
    return true
  }
  return /^\d{2}\.\d{2}\.\d{4}$/.test(dateString.replace(/\u200e/g, ''))
}

const validDate = (dateString) => {
  return moment(dateString, 'DD.MM.YYYY').isValid()
}

const validAge = (dateString) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const birthday = moment(dateString, 'DD.MM.YYYY')
  today.subtract(18, 'years')
  return (today.diff(birthday) >= 0)
}

const validGivenAge = (dateString, givenAge) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const birthday = moment(dateString, 'DD.MM.YYYY')
  today.subtract(givenAge, 'years')
  return (today.diff(birthday) >= 0)
}

// TODO Namensgebung irreführend
const validDatePeriod = (daysOfPeriod) => (dateString) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const dayToCheck = moment(dateString, 'DD.MM.YYYY')
  const minDay = today.subtract(daysOfPeriod + 1, 'days')
  return (dayToCheck.isAfter(minDay))
}

const isAfter = (before, after) => {
  const dtBefore = moment(before, 'DD.MM.YYYY')
  const dtAfter = moment(after, 'DD.MM.YYYY')
  return (dtAfter.isAfter(dtBefore))
}

const isSameOrAfter = (before, after) => {
  const dtBefore = moment(before, 'DD.MM.YYYY')
  const dtAfter = moment(after, 'DD.MM.YYYY')
  return (dtAfter.isSameOrAfter(dtBefore))
}

export {
  // checks the parsed value to be valid
  validDate,
  // checks for the general format xx.xx.xxxx
  validDateFormat,
  validDateFormatOnlyForNonEmpty,
  // check for age is over 18 years
  validAge,
  validGivenAge,
  // checks if date in the past is >= daysOfPeriod days ago
  validDatePeriod,
  isAfter,
  isSameOrAfter
}
